// extracted by mini-css-extract-plugin
export var bodyText1 = "body-text-module--bodyText1--3d111";
export var bodyText2 = "body-text-module--bodyText2--f9b2a";
export var bodyText3 = "body-text-module--bodyText3--b7546";
export var bodyText4 = "body-text-module--bodyText4--ce323";
export var bodyText5 = "body-text-module--bodyText5--99d45";
export var bodyText6 = "body-text-module--bodyText6--733bf";
export var bodyText7 = "body-text-module--bodyText7--39dc0";
export var bodyText8 = "body-text-module--bodyText8--c35f1";